export default "__VITE_ASSET__1HbzhVXh__"